import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getWelcomeState, WelcomeState } from './welcome.selectors';
import { SetWorkflowId } from 'apps/check-in-kiosk/src/app/actions/app.actions';

export enum WorkflowType {
  In = 'check-in',
  Out = 'check-out',
}

@Component({
  selector: 'frontend-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class WelcomeComponent {
  state$: Observable<WelcomeState>;
  workflowType = WorkflowType;
  showingWorkflowsOfType: WorkflowType | undefined;

  constructor(
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private store: Store<any>
  ) {
    iconRegistry.addSvgIcon(
      'hand',
      sanitizer.bypassSecurityTrustResourceUrl('assets/hand.svg')
    );
    this.state$ = this.store.pipe(select(getWelcomeState));
  }

  showIn() {
    this.showingWorkflowsOfType = this.workflowType.In;
  }

  showOut() {
    this.showingWorkflowsOfType = this.workflowType.Out;
  }

  reset() {
    this.showingWorkflowsOfType = undefined;
  }

  setWorkflowId(workflowId) {
    this.store.dispatch(new SetWorkflowId({ workflowId }));
  }
}
